export default __webpack_public_path__ + "static/mobile_KV12-3e8a3a4bd300703af9c8157cc5cfb6df.mp4";